// extracted by mini-css-extract-plugin
module.exports = {"FomrGrou":"style_FomrGrou__3v6FW"};